import React from "react";
import { connect, useDispatch } from "react-redux";
import { ResponsiveHeader } from "pages/_components/header";
import Button from "pages/_components/Button";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import { goBack } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";

import * as i18nUtils from "util/i18n";

const TermsAndConditionsPJ = () => {
    const dispatch = useDispatch();

    const handleAcceptTermsAndConditions = (isSelected) => {
        dispatch(onboardingActions.acceptTermsAndConditionsPJ(isSelected));
        dispatch(goBack());
    };

    return (
        <>
            <ResponsiveHeader ticket id="onboarding.vu.terms.and.conditions.pj.label" />
            <MainContainer>
                <div style={{ textAlign: "justify" }}>
                    <p>{i18nUtils.get("onboarding.vu.terms.and.conditions.text.pdf.pj")}</p>
                </div>
                <Row className="form-actions">
                    <Col xs={12} md={4} mdOffset={2}>
                        <Button
                            label="global.cancel"
                            className="btn btn-outline"
                            onClick={() => {
                                handleAcceptTermsAndConditions(false);
                            }}
                        />
                    </Col>
                    <Col xs={12} md={4}>
                        <Button
                            label="global.accept"
                            className="btn btn-primary"
                            onClick={() => {
                                handleAcceptTermsAndConditions(true);
                            }}
                        />
                    </Col>
                </Row>
            </MainContainer>
        </>
    );
};

TermsAndConditionsPJ.propTypes = {};

TermsAndConditionsPJ.defaultProps = {};

const mapStateToProps = (state) => ({
    fetching: onboardingSelectors.getFetching(state),
});

export default connect(mapStateToProps)(TermsAndConditionsPJ);
